// Carrusel 3D: cada balón es una esfera con la foto proyectada y pelo de felpa real, hecho con capas de fibras.
// Se apoya en botones normales para el teclado y lectores de pantalla, y cae a fotos planas si no hay WebGL.
(function () {
  var calm = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var mod = function (n, m) { return ((n % m) + m) % m; };

  function init(root) {
    if (root.__carousel) return;
    var orbit = root.querySelector("[data-orbit]");
    var orbs = Array.prototype.slice.call(orbit.querySelectorAll("[data-orb]"));
    var T = orbs.length;
    if (!T) return;
    var label = root.querySelector("[data-label]");
    var spec = root.querySelector("[data-spec-out]");
    var link = root.querySelector("[data-link]");
    var priceOut = root.querySelector("[data-price-out]");
    var dotsBox = root.querySelector("[data-dots]");
    var buyState = root.querySelector("[data-buy-state]");
    var notifies = root.querySelectorAll("[data-notify]");
    var autoplay = parseInt(root.getAttribute("data-autoplay"), 10) || 0;
    var bobOn = root.getAttribute("data-bob") === "true" && !calm;
    var furLength = (parseInt(root.getAttribute("data-fur"), 10) || 0) / 1000;
    var alive = true;
    var cleanups = [];
    var listen = function (el, type, fn, opts) { el.addEventListener(type, fn, opts); cleanups.push(function () { el.removeEventListener(type, fn, opts); }); };

    // ---------- selección ----------
    var target = 0;
    var pos = 0;
    var timer = null;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    dotsBox.innerHTML = "";
    orbs.forEach(function (o, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", "Ir a " + o.getAttribute("data-name"));
      b.addEventListener("click", function () { stop(); goTo(i); });
      dotsBox.appendChild(b);
    });
    var dots = dotsBox.querySelectorAll("button");
    function paint() {
      var i = mod(target, T);
      var o = orbs[i];
      var soon = o.hasAttribute("data-soon");
      var price = o.getAttribute("data-price");
      label.textContent = o.getAttribute("data-name");
      spec.textContent = o.getAttribute("data-spec");
      link.href = o.getAttribute("data-url");
      if (priceOut) { priceOut.textContent = price; priceOut.hidden = !price; }
      if (buyState) buyState.hidden = soon;
      notifies.forEach(function (n) { n.hidden = !(soon && n.getAttribute("data-notify") === o.getAttribute("data-id")); });
      orbs.forEach(function (x, k) { x.classList.toggle("is-center", k === i); });
      dots.forEach(function (b, k) {
        b.classList.toggle("is-on", k === i);
        if (k === i) b.setAttribute("aria-current", "true"); else b.removeAttribute("aria-current");
      });
    }
    function goTo(i) {
      var delta = mod(i - mod(target, T), T);
      if (delta > T / 2) delta -= T;
      target += delta;
      paint();
    }
    orbs.forEach(function (o, i) {
      listen(o, "click", function () {
        stop();
        if (i === mod(target, T)) {
          if (o.hasAttribute("data-soon")) {
            var open = root.querySelector('[data-notify="' + o.getAttribute("data-id") + '"] input[type="email"]');
            if (open) open.focus();
            return;
          }
          window.location.href = link.href;
          return;
        }
        goTo(i);
      });
    });
    // mientras escriben su correo, el carrusel no se mueve
    listen(root, "focusin", function (e) { if (e.target.tagName === "INPUT") stop(); });
    var prev = root.querySelector("[data-prev]");
    var next = root.querySelector("[data-next]");
    if (prev) listen(prev, "click", function () { stop(); target -= 1; paint(); });
    if (next) listen(next, "click", function () { stop(); target += 1; paint(); });
    var startX = null;
    listen(root, "touchstart", function (e) { startX = e.touches[0].clientX; }, { passive: true });
    listen(root, "touchend", function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) { stop(); target += dx < 0 ? 1 : -1; paint(); }
    }, { passive: true });
    paint();
    if (!calm && autoplay > 0 && T > 1 && !window.Shopify?.designMode) {
      timer = setInterval(function () { target += 1; paint(); }, autoplay * 1000);
    }

    // en el editor de Shopify, al tocar un bloque se muestra ese balón
    root.__select = function (id) {
      orbs.forEach(function (o, i) { if (o.getAttribute("data-id") === id) { stop(); goTo(i); } });
    };

    // al volver de registrarse, muestra el aviso correspondiente
    root.__showNotified = function (id) {
      var n = root.querySelector('[data-notify="' + id + '"]');
      if (!n) return;
      stop();
      orbs.forEach(function (o, i) { if (o.getAttribute("data-id") === id) { target = i; pos = i; } });
      var form = n.querySelector("form");
      var note = n.querySelector("[data-notify-note]");
      var ok = n.querySelector("[data-notify-ok]");
      if (form) form.hidden = true;
      if (note) note.hidden = true;
      if (ok) ok.hidden = false;
      paint();
    };

    root.__carousel = {
      destroy: function () {
        alive = false;
        stop();
        cleanups.forEach(function (fn) { fn(); });
        if (renderer) { renderer.dispose(); if (renderer.domElement.parentNode) renderer.domElement.parentNode.removeChild(renderer.domElement); }
        root.__carousel = null;
      }
    };

    // ---------- 3D ----------
    var renderer = null;
    try {
      if (!window.THREE) throw new Error("sin three");
      renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: "low-power" });
    } catch (e) {
      renderer = null;
      root.classList.add("no-webgl");
      return;
    }
    var canvas = renderer.domElement;
    canvas.setAttribute("aria-hidden", "true");
    orbit.insertBefore(canvas, orbit.firstChild);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setClearColor(0x000000, 0);
    var scene = new THREE.Scene();
    var FOV = 30;
    var camera = new THREE.PerspectiveCamera(FOV, 1, 10, 20000);

    // Felpa: capas de la esfera, cada una un poco más afuera; en cada capa solo sobreviven las puntas de las fibras.
    var vert = [
      "uniform float shell;",
      "varying vec3 vDir; varying vec3 vN;",
      "void main(){",
      "  vDir = normalize(position);",
      "  vN = normalize(normalMatrix * normal);",
      "  vec3 p = position * (1.0 + shell * " + furLength.toFixed(4) + ");",
      "  p.y -= shell * shell * " + (furLength * 0.24).toFixed(4) + ";",
      "  gl_Position = projectionMatrix * modelViewMatrix * vec4(p, 1.0);",
      "}"
    ].join("\n");
    var frag = [
      "precision highp float;",
      "uniform sampler2D map; uniform float alpha; uniform float dim; uniform float shell;",
      "varying vec3 vDir; varying vec3 vN;",
      "float hash(vec3 p){ return fract(sin(dot(p, vec3(127.1, 311.7, 74.7))) * 43758.5453); }",
      "void main(){",
      "  vec3 d = normalize(vDir);",
      "  vec3 q = d * 125.0 + 3.2 * vec3(sin(d.y * 15.0 + d.z * 7.0), sin(d.z * 13.0 + d.x * 9.0), sin(d.x * 14.0 + d.y * 8.0));",
      "  q += shell * 0.9 * vec3(sin(d.z * 23.0), cos(d.x * 21.0), sin(d.y * 19.0));",
      "  float rnd = hash(floor(q));",
      "  float strand = 1.0 - length(fract(q) - 0.5) / 0.72;",
      "  if (shell > 0.0 && strand * (0.62 + 0.55 * rnd) < shell * 0.72) discard;",
      "  vec3 c = texture2D(map, 0.5 + 0.5 * d.xy * 0.99).rgb;",
      "  float n = clamp(vN.z, 0.0, 1.0);",
      "  c *= mix(0.86, 1.03, shell) * mix(0.95, 1.04, rnd);",
      "  c *= mix(0.78, 1.02, pow(n, 0.5));",
      "  c += vec3(0.075 * rnd) * shell * shell;",
      "  c += vec3(0.08) * shell * pow(1.0 - n, 2.4);",
      "  gl_FragColor = vec4(c * dim, alpha);",
      "}"
    ].join("\n");

    var LAYERS = furLength === 0 ? 1 : (window.innerWidth < 760 ? 8 : 12);
    var geo = new THREE.SphereGeometry(1, 96, 64);
    var loader = new THREE.TextureLoader();
    loader.setCrossOrigin("anonymous");
    var maxAniso = renderer.capabilities.getMaxAnisotropy();

    var shadowCanvas = document.createElement("canvas");
    shadowCanvas.width = shadowCanvas.height = 256;
    var sc = shadowCanvas.getContext("2d");
    var grad = sc.createRadialGradient(128, 128, 0, 128, 128, 128);
    grad.addColorStop(0, "rgba(38,28,18,.62)");
    grad.addColorStop(.55, "rgba(38,28,18,.2)");
    grad.addColorStop(1, "rgba(38,28,18,0)");
    sc.fillStyle = grad;
    sc.fillRect(0, 0, 256, 256);
    var shadowTex = new THREE.CanvasTexture(shadowCanvas);
    var shadowGeo = new THREE.PlaneGeometry(1, 1);

    var balls = orbs.map(function (o, i) {
      var shared = { map: { value: null }, alpha: { value: 1 }, dim: { value: 1 } };
      var group = new THREE.Group();
      group.visible = false;
      for (var k = 0; k < LAYERS; k++) {
        var mat = new THREE.ShaderMaterial({
          vertexShader: vert,
          fragmentShader: frag,
          transparent: true,
          uniforms: { map: shared.map, alpha: shared.alpha, dim: shared.dim, shell: { value: LAYERS > 1 ? k / (LAYERS - 1) : 0 } }
        });
        var layer = new THREE.Mesh(geo, mat);
        layer.renderOrder = k;
        group.add(layer);
      }
      scene.add(group);
      var shadowMat = new THREE.MeshBasicMaterial({ map: shadowTex, transparent: true, depthWrite: false });
      var shadow = new THREE.Mesh(shadowGeo, shadowMat);
      shadow.renderOrder = -1;
      scene.add(shadow);
      loader.load(o.getAttribute("data-tex"), function (tx) {
        tx.anisotropy = maxAniso;
        shared.map.value = tx;
        group.visible = true;
      });
      return { group: group, oval: o.getAttribute("data-shape") === "oval", shared: shared, shadow: shadow, shadowMat: shadowMat, btn: o, phase: i * 1.37 };
    });

    var W = 0, H = 0, ORB = 0, D = 0, small = false;
    function resize() {
      W = orbit.clientWidth;
      H = orbit.clientHeight;
      var probe = document.createElement("div");
      probe.style.cssText = "position:absolute;width:var(--orb);height:0;visibility:hidden";
      root.appendChild(probe);
      ORB = probe.offsetWidth || 300;
      root.removeChild(probe);
      small = W < 760;
      renderer.setSize(W, H, false);
      camera.aspect = W / H;
      D = H / 2 / Math.tan((FOV * Math.PI) / 360);
      camera.position.set(0, 0, D);
      camera.lookAt(0, 0, 0);
      camera.updateProjectionMatrix();
    }
    listen(window, "resize", resize);
    resize();

    // el balón del centro mira hacia el cursor
    var tiltX = 0, tiltY = 0, wantX = 0, wantY = 0;
    listen(orbit, "pointermove", function (e) {
      if (e.pointerType === "touch") return;
      var r = orbit.getBoundingClientRect();
      wantY = ((e.clientX - r.left) / r.width - 0.5) * 0.9;
      wantX = ((e.clientY - r.top) / r.height - 0.5) * 0.6;
    });
    listen(orbit, "pointerleave", function () { wantX = 0; wantY = 0; });

    var visible = true;
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (es) { visible = es[0].isIntersecting; });
      io.observe(root);
      cleanups.push(function () { io.disconnect(); });
    }
    var last = performance.now();
    function frame(now) {
      if (!alive) return;
      requestAnimationFrame(frame);
      if (!visible) { last = now; return; }
      var dt = Math.min((now - last) / 1000, 0.5);
      last = now;
      var t = now / 1000;
      pos += (target - pos) * (calm ? 1 : 1 - Math.exp(-dt * 5.5));
      tiltX += (wantX - tiltX) * (1 - Math.exp(-dt * 6));
      tiltY += (wantY - tiltY) * (1 - Math.exp(-dt * 6));
      var step = small ? W * 0.47 : Math.min(W * 0.19, 280);
      var baseY = H * 0.03;
      balls.forEach(function (b, i) {
        var d = mod(i - pos + T / 2, T) - T / 2;
        var a = Math.abs(d);
        var near = Math.max(0, 1 - a);
        var s = 1.08 - 0.29 * Math.min(a, 1) - 0.13 * Math.max(a - 1, 0);
        var radius = (ORB / 2) * s * 0.96;
        var bob = bobOn ? Math.sin(t * 1.37 + b.phase) * ORB * (0.012 + 0.018 * near) : 0;
        var x = d * step;
        var y = baseY - a * a * 6 + bob;
        var z = -a * 130;
        b.group.position.set(x, y, z);
        b.group.scale.set((b.oval ? 1.2 : 1) * radius, (b.oval ? 0.74 : 1) * radius, (b.oval ? 0.74 : 1) * radius);
        var sway = calm ? 0 : Math.sin(t * 0.55 + b.phase) * (0.2 + 0.2 * near);
        b.group.rotation.y = -d * 0.32 + sway + tiltY * near;
        b.group.rotation.x = (calm ? 0 : Math.sin(t * 0.43 + b.phase) * 0.07) + tiltX * near;
        b.group.rotation.z = b.oval ? 0.19 : 0;
        var fade = Math.min(1, Math.max(0, (2.45 - a) / 0.3));
        b.shared.alpha.value = fade;
        b.shared.dim.value = 1 - 0.05 * Math.min(a, 2);
        var floorY = baseY - a * a * 6 - radius * (b.oval ? 0.8 : 1.02);
        b.shadow.position.set(x, floorY, z - radius * 0.2);
        b.shadow.scale.set(radius * (b.oval ? 1.95 : 1.62), radius * 0.24, 1);
        b.shadowMat.opacity = fade * (1 - (bob / (ORB * 0.03)) * 0.16) * 0.95;
        // el botón invisible sigue al balón
        var f = D / (D - z);
        var size = radius * 2 * f;
        b.btn.style.width = size + "px";
        b.btn.style.height = size + "px";
        b.btn.style.transform = "translate(" + (W / 2 + x * f - size / 2).toFixed(1) + "px," + (H / 2 - y * f - size / 2).toFixed(1) + "px)";
        b.btn.style.visibility = fade < 0.2 ? "hidden" : "visible";
        b.btn.style.zIndex = String(20 - Math.round(a));
      });
      renderer.render(scene, camera);
    }
    requestAnimationFrame(frame);
  }

  function initAll() { document.querySelectorAll("[data-carousel]").forEach(init); }
  initAll();
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:unload", function (e) {
    var root = e.target.querySelector("[data-carousel]");
    if (root && root.__carousel) root.__carousel.destroy();
  });
  document.addEventListener("shopify:block:select", function (e) {
    var root = e.target.closest("[data-carousel]");
    if (root && root.__select) root.__select(e.target.getAttribute("data-id"));
  });
  window.dispatchEvent(new CustomEvent("mrhoms:carousel-ready"));
})();
